import React from 'react';
import { Route, Switch } from "react-router-dom";
import AuthRoute from '../session/AuthRoute';
import NotFound from '../error/NotFound';
import EventLogDetail from './eventLogDetail/EventLogDetail';
import './EventLog.css';

const EventLog = (props) => {
  return (
    <div className="eventLogContainer">
      <Switch>
        <AuthRoute
            exact path="/eventLog"
            render={props => <EventLogDetail {...props} />}
          />
        <AuthRoute
            path="/eventLog/detail"
            render={props => <EventLogDetail {...props} />}
          />
        <Route render={NotFound} />
      </Switch>
    </div>
  )
}

export default EventLog;